import React, { useCallback, useMemo } from "react";
import "./index.scss";
import { TabPane, Row, Col } from "reactstrap";
import CustomDropdownInput from "components/CustomDropdownInput";
import CustomTextInput from "components/CustomTextInput";
import { getLayoutType } from "utils/SiteHelper";
import _ from "lodash";

type OtherTabProps = {
  isView: boolean;
  siteData: any;
  setSiteData: Function;
  tabId: string;
  groups: Array<any>;
};

const OtherTab = ({
  isView,
  setSiteData,
  siteData,
  tabId,
  groups,
}: OtherTabProps) => {
  const uiLayoutDefinition = useMemo(() => {
    if (_.isEmpty(groups)) {
      return []
    }

    return groups.map((group: any) => {
      return {
        type: "row",
        label: group.name,
        items:
          group.fields?.map((field: any) => {
            const extra = field.extra_data;
            const options = Object.keys(extra).map((k) => ({
              label: extra[k],
              value: extra[k],
            }));

            return {
              attributeName: field.code,
              type: getLayoutType(field.field_data_type),
              size: 6,
              options,
              label: field.name,
              isNumeric: field.field_data_type === "number",
              isDecimal: field.field_data_type === "decimal"
            };
          }) || [],
      };
    })
  }, [groups]);

  const updateAttr = useCallback((attribute: string, value: any) => {
    setSiteData((currentData: any) => {
      return {
        ...currentData,
        data: {
          ...currentData.data,
          [attribute]: _.has(value, 'value') ? value.value : value,
        }
      };
    });
  }, [setSiteData]);

  return (
    <TabPane tabId={tabId}>
      {uiLayoutDefinition.map((row: any, index: number) => (
        <div key={index}>
          <h4 className="site-summary__label-title">{row.label}</h4>
          <Row className="site-information-tab__section">
            {row.items.map((layoutItem: any, layoutIndex: number) => {
              if (layoutItem.type === "dropdown") {
                return (
                  <Col
                    key={`layout-${index}-${layoutIndex}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    <CustomDropdownInput
                      disabled={layoutItem.isView || isView}
                      style={styles.customTextInput}
                      callback={updateAttr}
                      data={siteData?.data}
                      options={layoutItem.options}
                      labelText={layoutItem.label}
                      attributeName={layoutItem.attributeName}
                    />
                  </Col>
                );
              } else if (
                layoutItem.type === "text" ||
                layoutItem.type === "textarea" ||
                layoutItem.type === "date"
              ) {
                return (
                  <Col
                    key={`layout-index-${layoutIndex}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    <CustomTextInput
                      type={layoutItem.type}
                      isNumeric={layoutItem.isNumeric || false}
                      isDecimal={layoutItem.isDecimal || false}
                      disabled={layoutItem.isView || isView}
                      style={styles.customTextInput}
                      callback={updateAttr}
                      data={siteData?.data}
                      labelText={layoutItem.label}
                      attributeName={layoutItem.attributeName}
                      inputBoxRows={layoutItem.inputBoxRows}
                    />
                  </Col>
                );
              } else if (layoutItem.type === "break") {
                return (
                  <Col
                    key={`layout-index-${layoutIndex}`}
                    sm={{ size: 6, offset: 0 }}
                  />
                );
              } else if (layoutItem.type === "custom") {
                return (
                  <Col
                    key={`layout-index-${layoutIndex}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    {layoutItem.component}
                  </Col>
                );
              }
            })}
          </Row>
        </div>
      ))}
    </TabPane>
  );
};

const styles = {
  customTextInput: {
    marginTop: 20,
  },
  controlButton: {
    marginTop: 12,
    marginBottom: 12,
  },
  mapDiv: {
    marginTop: 12,
    marginBottom: 12,
  },
};

export default OtherTab;
